import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsInternalUserGroupsAnonymousUsers = "/internal_user_groups/anonymous_users";
export const appSettingsInternalUserGroupsAnonymousUsersCacheKeys: AllRouteEndpoints[] = [
  appSettingsInternalUserGroupsAnonymousUsers,
];
